import { FC } from "react";
import { ActivityDataWithType } from "../types";
import {
  FactorActivity,
  FactorActivityAction,
  FactorActivityDataWithType,
} from "./types";
import Container, { EmptyContainer } from "../../meta-container";
import FactorReceiveActivity from "./factor-receive-activity";
import FactorUpdateActivity from "./factor-update-activity";
import FactorDeleteActivity from "./factor-delete-activity";
import FactorSpendActivity from "./factor-spend-activity";

const FactorActivityRenderer: FC<ActivityDataWithType> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as FactorActivity;
  return (
    <Container<FactorActivityAction, FactorActivityDataWithType>
      data={{ type, activity: activity_.data, by, date }}
      type={activity_.action}
      match={{
        [FactorActivityAction.None]: EmptyContainer,
        [FactorActivityAction.Receive]: FactorReceiveActivity,
        [FactorActivityAction.Update]: FactorUpdateActivity,
        [FactorActivityAction.Delete]: FactorDeleteActivity,
        [FactorActivityAction.Spend]: FactorSpendActivity,
      }}
    />
  );
};

export default FactorActivityRenderer;
